import React from 'react';
import { LoginLayout } from 'layout';
import '@isyc-react/design/main';
import 'assets/css/login.css';
import { RestorePasswordForm } from 'common/auth/modules/pods/login';
export const RestorePasswordScene = () => {
    return (React.createElement(LoginLayout, null,
        React.createElement(RestorePasswordForm, { successButton: true })));
};
